import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { ModalSingleInput } from '@/lib/v2/organisms';

import { useActionsRecurringMessage } from '@/src/modules/AutomationModuleNew/hooks/useActionsRecurringMessage';
import { useRulesValidations } from '@/src/modules/AutomationModuleNew/hooks/useRulesValidations';

type EditRecurringMessageModalProps = {
  isOpen: boolean;
  onClose: () => void;
  campaignID: number;
  nameRecurringMessage: string;
  refetchData: () => void;
};

const EditRecurringMessageModal = ({
  isOpen,
  onClose,
  campaignID,
  refetchData,
  nameRecurringMessage,
}: EditRecurringMessageModalProps) => {
  const { t } = useTranslation();
  const { VALIDATION_RULES } = useRulesValidations();
  const { editRecurringMessage, isLoading, isValidationLoading, handleValidation } =
    useActionsRecurringMessage();

  const handleSubmitEdition = useCallback(
    async (name: string) => {
      await editRecurringMessage(name, campaignID);
      onClose();
      refetchData();
    },
    [campaignID, editRecurringMessage, onClose, refetchData]
  );

  return (
    <ModalSingleInput
      defaultValue={nameRecurringMessage}
      disabled={isValidationLoading || isLoading}
      disabledSubmitButton={isValidationLoading || isLoading}
      id="create-recurrent-action-modal"
      isLoading={isLoading || isValidationLoading}
      isOpen={isOpen}
      rules={VALIDATION_RULES}
      title={t(`RECURRENT_MESSAGE.CREATE_RECURRENT.titleModalEdit`)}
      onClose={onClose}
      onSubmit={handleSubmitEdition}
      onValidateInputFetch={handleValidation}
    />
  );
};

export default EditRecurringMessageModal;
